import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

export default function ChangePasswordModal({ isOpen, onClose, onSubmit }) {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [visiblePasswords, setVisiblePasswords] = useState({});

  const newPassword = watch("newPassword");

  useEffect(() => {
    if (isOpen) {
      reset({
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      setVisiblePasswords({});
    }
  }, [isOpen, reset]);

  if (!isOpen) return null;

  const togglePassword = (name) => {
    setVisiblePasswords((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const closeModal = () => {
    reset();
    setVisiblePasswords({});
    onClose?.();
  };

  const submitHandler = async (data) => {
    await onSubmit?.({
      oldPassword: data.oldPassword,
      newPassword: data.newPassword,
    });
  };

  const passwordType = (name) => (visiblePasswords[name] ? "text" : "password");

  return (
    <div
      id="changePasswordModal"
      className="pop_bg"
      style={{
        height: "100%",
        width: "100%",
        display: "block",
      }}
      onClick={closeModal}
    >
      <div className="pop_box pop_refer" onClick={(e) => e.stopPropagation()}>
        {/* Close */}
        <a
          href="#"
          className="close_pop"
          onClick={(e) => {
            e.preventDefault();
            closeModal();
          }}
        >
          close_pop
        </a>

        {/* Header */}
        <h3 className="modal-header">Change Password</h3>

        <form
          noValidate
          style={{
            display: "flex",
            flexFlow: "column",
          }}
          onSubmit={handleSubmit(submitHandler)}
        >
          <div id="modalid" className="modal-content">
            <ul className="half_box add-member-box">
              <li className="add_account_box">
                <dl>
                 
                  {/* New Password */}
                  <div
                    style={{
                      position: "relative",
                      marginBottom: "15px",
                    }}
                  >
                    <dt>New Password</dt>

                    <dd style={{ position: "relative" }}>
                      <input
                        id="newPassword"
                        type={passwordType("newPassword")}
                        maxLength={20}
                        autoComplete="new-password"
                        placeholder="Enter"
                        {...register("newPassword", {
                          required: "New password is required.",

                          minLength: {
                            value: 8,
                            message: "Password must be at least 8 characters.",
                          },

                          maxLength: {
                            value: 20,
                            message: "Password cannot exceed 20 characters.",
                          },

                          // validate: (value) => {
                          //   if (!/[A-Z]/.test(value)) {
                          //     return "Password must contain at least one uppercase letter.";
                          //   }
                          //   if (!/[a-z]/.test(value)) {
                          //     return "Password must contain at least one lowercase letter.";
                          //   }
                          //   if (!/[0-9]/.test(value)) {
                          //     return "Password must contain at least one number.";
                          //   }
                          //   if (!/[^A-Za-z0-9]/.test(value)) {
                          //     return "Password must contain at least one special character.";
                          //   }
                          //   return true;
                          // },
                        })}
                      />

                      <span className="must rg-mark">＊</span>

                      <i
                        aria-hidden="true"
                        className={`fa ${visiblePasswords.newPassword ? "fa-eye" : "fa-eye-slash"} fa-xs pass-eye`}
                        style={{
                          color: "#000",
                          top: "7px",
                          right: "10px",
                          position: "absolute",
                          opacity: 0.9,
                          cursor: "pointer",
                        }}
                        onClick={() => togglePassword("newPassword")}
                      />

                      {errors.newPassword && (
                        <span id="newPasswordErrorText" className="error-text">
                          {errors.newPassword.message}
                        </span>
                      )}
                    </dd>
                  </div>

                  {/* Confirm Password */}
                  <div
                    style={{
                      position: "relative",
                      marginBottom: "15px",
                    }}
                  >
                    <dt>Confirm Password</dt>

                    <dd style={{ position: "relative" }}>
                      <input
                        id="confirmPassword"
                        type={passwordType("confirmPassword")}
                        maxLength={20}
                        autoComplete="new-password"
                        placeholder="Enter"
                        {...register("confirmPassword", {
                          required: "Please confirm your new password.",

                          validate: (value) => {
                            if (value !== newPassword) {
                              return "New password and confirm password do not match.";
                            }
                            return true;
                          },
                        })}
                      />

                      <span className="must rg-mark">＊</span>

                      <i
                        aria-hidden="true"
                        className={`fa ${visiblePasswords.confirmPassword ? "fa-eye" : "fa-eye-slash"} fa-xs pass-eye`}
                        style={{
                          color: "#000",
                          top: "7px",
                          right: "10px",
                          position: "absolute",
                          opacity: 0.9,
                          cursor: "pointer",
                        }}
                        onClick={() => togglePassword("confirmPassword")}
                      />

                      {errors.confirmPassword && (
                        <span id="confirmPasswordErrorText" className="error-text">
                          {errors.confirmPassword.message}
                        </span>
                      )}
                    </dd>
                  </div>
                   {/* Old / Your Password */}
                  <div
                    style={{
                      position: "relative",
                      marginBottom: "15px",
                    }}
                  >
                    <dt>Your Password</dt>

                    <dd style={{ position: "relative" }}>
                      <input
                        id="oldPassword"
                        type={passwordType("oldPassword")}
                        maxLength={20}
                        autoComplete="current-password"
                        placeholder="Enter"
                        {...register("oldPassword", {
                          required: "Please enter your  password.",
                        })}
                      />

                      <span className="must rg-mark">＊</span>

                      <i
                        aria-hidden="true"
                        className={`fa ${visiblePasswords.oldPassword ? "fa-eye" : "fa-eye-slash"} fa-xs pass-eye`}
                        style={{
                          color: "#000",
                          top: "7px",
                          right: "10px",
                          position: "absolute",
                          opacity: 0.9,
                          cursor: "pointer",
                        }}
                        onClick={() => togglePassword("oldPassword")}
                      />

                      {errors.oldPassword && (
                        <span id="oldPasswordErrorText" className="error-text">
                          {errors.oldPassword.message}
                        </span>
                      )}
                    </dd>
                  </div>

                </dl>
              </li>
            </ul>
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <div style={{ width: "100%" }} className="btn_box">
              <button style={{ marginTop: "0" }} type="submit" className="btn-send size-btn" disabled={isSubmitting}>
                {isSubmitting ? "Changing..." : "Change Password"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
